import { defineStore } from 'pinia';
import { ref } from 'vue';

// In-memory cache of full vehicle documents fetched by the detail page,
// keyed by id. Lets every revisit (from any entry point) render instantly
// from the previously-fetched doc instead of flashing a loading spinner
// while it refetches. Read-through only — the detail page populates it.
export default defineStore('vehicleCacheStore', () => {
  const byId = ref({});
  return {
    get: (id) => byId.value[id] ?? null,
    set: (id, doc) => { if (id && doc) byId.value[id] = doc; }
  };
});
